import { Trans } from '@lingui/react/macro';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@pantry/ui';

interface DeleteListDialogProps {
  open: boolean;
  listName: string;
  isPending?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog for deleting a shopping list.
 */
export function DeleteListDialog({
  open,
  listName,
  isPending,
  onClose,
  onConfirm,
}: DeleteListDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Trans context="dialog_title">Delete List</Trans>
          </DialogTitle>
          <DialogDescription>
            <Trans>
              Are you sure you want to delete &ldquo;{listName}&rdquo;? This action cannot be
              undone.
            </Trans>
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-end gap-2 mt-2">
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            <Trans context="action_button">Cancel</Trans>
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isPending}>
            {isPending ? <Trans>Deleting...</Trans> : <Trans context="action_button">Delete</Trans>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
